import React from "react";
import PublicRoutes from "./routes/index";
import SessionWarning from "./components/common/SessionWarning/SessionWarning";
import "./App.css";

const App = () => (
  <>
    <SessionWarning />
    <PublicRoutes />
  </>
);

export default App;
